import {
  ACTION_REGISTER__REQUEST,
  ACTION_REGISTER__SUCCESS,
  ACTION_REGISTER__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_REGISTER__REQUEST:
    case ACTION_REGISTER__SUCCESS:
      return null;

    case ACTION_REGISTER__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
